module.exports = __webpack_public_path__ + "static/media/costcase9.10f55959.png";